export default __webpack_public_path__ + "static/media/nepal_icon.dc791a0d.svg";